import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getApiUrl } from "../helpers/Util";
import { createNotification } from "../helpers/Notification";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import MasterDataService from "../services/MasterDataService";
import AccessDenied from '../common/AccessDenied';
import { rules, Permission } from "../../abac.config";
import { AllowedTo } from "react-abac";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ConfirmBox from "../common/ConfirmBox";
import { setLocalStorageMasterDataItems, getLocalStorageMasterDataItems, removeLocalStorageMasterDataItems } from "../project/Helper";
import Loader from "../common/Loader";
class QcList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [],
      search: "",
      isShowConfirmBox: false,
      loader: false,
      removeId: "",
      resDataLen: 0,
      // pagination constants-------
      pageChange: 1,
      skip: 0,
      limit: 10,
      count: 0,
    };
  }

  componentDidMount = () => {
    this.getQcPaginationConstants();

  };

  getQcPaginationConstants = () => {
    const { skip, limit } = this.state;
    const data = getLocalStorageMasterDataItems("qcListPaginationConstants");
    console.log(data);
    let filters
    if (data !== null && data !== undefined) {

      const { qcLimit, qcPageChange, qcSkip } = data;
      this.setState({ pageChange: qcPageChange, limit: qcLimit, skip: qcSkip }, () => {
        filters = `?filter[skip]=${qcSkip}&filter[limit]=${qcLimit}`
        this.getQcList(filters);
        removeLocalStorageMasterDataItems("qcListPaginationConstants")
      })

    } else {

      filters = `?filter[skip]=${skip}&filter[limit]=${limit}`;
      this.getQcList(filters);
    }
  }
  getQcList = async (filters) => {

    MasterDataService.getQcs(filters)
      .then((response) => {
        if (response.status) {
          // console.log(response.data.data.count);

          let responseData = response.data.data;
          this.setState({ userData: responseData.data, count: responseData.count, resDataLen: responseData.data.length });
          // this.handleUserList(responseData);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          createNotification("error", "Your login session has been expired!");
          localStorage.clear();
          this.props.history.push("/login");
          //this.setState({loader:false});
        } else {
          createNotification("error", error.response.data.error.message);
          //this.setState({loader:false});
        }
      });
  };

  handleConfirmModal = (isYes, id = "") => {
    if (isYes) {
      this.setState({
        isShowConfirmBox: !this.state.isShowConfirmBox,
        loader: true,
      });
      const { removeId, resDataLen, pageChange, skip, limit } = this.state;
      let filters;
      if (resDataLen === 1 && pageChange > 1) {

        let localskip = this.state.skip - this.state.limit;
        let localPage = this.state.pageChange - 1;
        console.log(localPage);
        this.setState({ skip: localskip, pageChange: localPage }, () => {
          filters = `?filter[skip]=${localskip}&filter[limit]=${this.state.limit}`;
        })

      } else {
        filters = `?filter[skip]=${this.state.skip}&filter[limit]=${this.state.limit}`;

      }
      MasterDataService.deleteQcById(removeId)
        .then((response) => {
          if (response.status) {
            createNotification("success", "Qc deleted successfully");
            this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
            this.getQcList(filters);
          }
          console.log({ locationList: response });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            createNotification("error", "Your login session has been expired!");
            localStorage.clear();
            this.props.history.push("/login");
            //this.setState({loader:false});
          } else {
            createNotification("error", error.response.data.error.message);
            //this.setState({loader:false});
            this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
          }
        });
    } else {
      this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
    }
  };

  handleUserList = (responseData) => {
    const URL = getApiUrl();
    let listArr = [];
    responseData.data &&
      responseData.data.map((item, index) => {
        let itemData = { ...item };
        itemData.project_key = index
        itemData.role = itemData.role_fkey && itemData.role_fkey.title;
        itemData.status =
          itemData.status.charAt(0).toUpperCase() + itemData.status.slice(1);
        itemData.profilePic =
          itemData.upload_fkey && URL + itemData.upload_fkey.filePath;
        listArr.push(itemData);
      });
    // this.setState({ userData: listArr,count: responseData.count});
  };

  imageFormat = (cell, row, rowIndex, formatExtraData) => {
    const image =
      row.profilePic == undefined ||
        row.profilePic == "undefined" ||
        row.profilePic == null
        ? "/assets/images/profile-pic.jpeg"
        : row.profilePic;
    return (
      <div>
        {/* <img src={image} alt="" className="avatar-xs rounded-circle me-2" /> */}
        <a href="#" className="text-body">
          {row.name}
        </a>
      </div>
    );
  };

  setLocalStorageItems = () => {

    const { pageChange, skip, limit } = this.state;
    let data = {
      qcPageChange: pageChange,
      qcSkip: skip,
      qcLimit: limit
    }
    setLocalStorageMasterDataItems("qcListPaginationConstants", data);
  }

  actionFormat = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <td>
          <ul className="list-inline mb-0">
            <li className="list-inline-item" onClick={() => this.setLocalStorageItems()}>
              <Link to={`/qc/${row.id}`}>
                <i className="uil uil-pen font-size-18"></i>
              </Link>
            </li>
            <li className="list-inline-item">
              <a href="javascript:void(0)" className="text-danger">
                <i className="uil uil-trash-alt font-size-18" onClick={() => this.setState({ removeId: row.id, isShowConfirmBox: true })}></i>
              </a>
            </li>
          </ul>
        </td>
      </div>
    );
  };

  handleSearchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      this.getQcList();
    });
  };

  render() {
    const { userData, isShowConfirmBox, pageChange, limit, count } = this.state;
    console.log(count);

    //console.log({ userData });
    const handleOnTableChange = (type, newState) => {
      console.log("type", type);
      if (type === "sort") {
        if (newState.sortOrder == "asc") {
          userData.sort((obj1, obj2) => {
            return obj1[newState.sortField].trim().localeCompare(obj2[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' })
              ;
          });
        }
        else {
          userData.sort((obj2, obj1) => {
            return obj1[newState.sortField].trim().localeCompare(obj2[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' })
              ;
          });
        }
      }

    }
    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: this.imageFormat,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true
      },
      {
        dataField: "",
        text: "Action",
        formatter: this.actionFormat,
      },
    ];

    const sizePerPageOptions = [
      {
        text: '10',
        value: 10,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '30',
        value: 30,
      },
      {
        text: '50',
        value: 50,

      },
      {
        text: '100',
        value: 100,
      },
      // Add more options as needed
    ];
    let that = this;
    const pagination = paginationFactory({
      page: pageChange,
      sizePerPage: limit,
      lastPageText: ">>",
      firstPageText: "<<",
      nextPageText: ">",
      prePageText: "<",
      totalSize: count,
      hideSizePerPage: false,
      alwaysShowAllBtns: true,
      sizePerPageList: sizePerPageOptions,
      onPageChange: function (page, sizePerPage) {
        let skp = (page - 1) * sizePerPage;
        let filters = `?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
        that.setState({ pageChange: page, skip: skp });
        that.getQcList(filters);
      },
      onSizePerPageChange: function (sizePerPage, page) {
        let skp = (page - 1) * sizePerPage;
        that.setState({ pageChange: page, skip: skp, limit: sizePerPage });
        let filters = `?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
        that.getQcList(filters);
      }
    })
    let roleKey = this.props.loginUserData.roleKey;
    const isAccess = (roleKey !== "" && rules[roleKey][Permission.MASTER_WRITE]) ? true : false;

    return (
      <div>
        {!isAccess ? <AccessDenied /> :
          <div className="main-content">
            <ConfirmBox
              openModal={isShowConfirmBox}
              confirmMsg="Are you sure to delete this QC?"
              handleConfirmModal={this.handleConfirmModal}
            />
            <div className="page-content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="page-title-box d-flex align-items-center justify-content-between">
                      <ol className="breadcrumb m-0">
                        <Link to={`/#`}><li className="breadcrumb-item">Home</li></Link>
                        &nbsp; / &nbsp;
                        <Link to={`/qc`}><li className="breadcrumb-item">QC</li></Link>
                      </ol>
                    </div>
                    <h4 className="mb-0">QC List</h4>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="card card-block">
                      <div className="card-body">
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <Link to="/addqc">
                                <span className="btn btn-success waves-effect waves-light" onClick={this.setLocalStorageItems}>
                                  <i className="uil uil-plus"></i> Add New
                                </span>
                              </Link>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-inline float-md-end mb-3">
                              <div className="search-box ms-2">
                                {/* <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control rounded bg-light border-0"
                                  placeholder="Search..."
                                  onChange={(e) => this.handleSearchUser(e)}
                                />
                                <i className="uil uil-search search-icon"></i>
                              </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <BootstrapTable
                          remote={{
                            pagination: true,
                            sort: true
                          }}
                          keyField="project_key"
                          data={userData}
                          columns={columns}
                          onTableChange={handleOnTableChange}
                          // pagination={paginationFactory({   sizePerPageList:sizePerPageOptions })} 
                          pagination={pagination}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    loginUserData: props.loginUserData,
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QcList);